import React from "react"
import { arrayOf, string, shape, node, bool } from "prop-types"
import classNames from "classnames"
import Typograph from "components/Typograph/index"
import ThemeConsumer from "../ThemeConsumer"

const List = ({ theme, children, items, multicolumn }) => {
  const mapKV = (item, i) => ({ key: `${item}${i}`, value: item })

  const classes = classNames(
    { [theme.list]: !multicolumn },
    { [theme.multicolumn]: multicolumn }
  )

  return (
    <div className={theme.listContainer}>
      <ul className={classes}>
        {items.map(mapKV).map((item) => (
          <li key={item.key} className={theme.pr4}>
            <Typograph htmlTag="span" preset="h2">
              {item.value}
            </Typograph>
          </li>
        ))}
      </ul>
      {children}
    </div>
  )
}

List.propTypes = {
  theme: shape({ list: string }),
  children: node,
  items: arrayOf(string).isRequired,
  multicolumn: bool
}

List.defaultProps = {
  theme: {},
  children: null,
  multicolumn: false
}

export default ThemeConsumer("UIList")(List)



// WEBPACK FOOTER //
// ./src/shared/components/List/List.js